import React from "react";
import clsx from "clsx";
import { Skeleton } from "@mui/material";
import "./LearningCardSkeleton.scss";

/**
 * Componente skeleton para LearningCard durante estados de carga
 * @param {Object} props - Propiedades del componente
 * @param {string} [props.className=""] - Clases CSS adicionales
 * @returns {JSX.Element} Componente skeleton de card de aprendizaje
 */
export const LearningCardSkeleton = ({ className = "", ...props }) => {
  return (
    <div
      className={clsx("learning-card-skeleton-wrapper", className)}
      {...props}
    >
      <div className="learning-card-skeleton">
        <div className="learning-card-skeleton__header">
          <Skeleton variant="text" width="40%" height={24} animation="wave" />
          <div className="learning-card-skeleton__divider" />
          <Skeleton variant="text" width="30%" height={16} animation="wave" />
        </div>

        <Skeleton
          variant="rectangular"
          width="100%"
          height={14}
          animation="wave"
          sx={{ borderRadius: 2 }}
        />

        <div className="learning-card-skeleton__iframe-container">
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
            sx={{ borderRadius: 2 }}
          />
        </div>

        <div className="learning-card-skeleton__support">
          <Skeleton variant="text" width="25%" height={18} animation="wave" />
          <div className="learning-card-skeleton__support-btns">
            {[...Array(5)].map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                width="100%"
                height={46}
                animation="wave"
                sx={{ borderRadius: 2 }}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="learning-card-skeleton__actions">
        <Skeleton
          variant="rectangular"
          width="100%"
          height={46}
          animation="wave"
          sx={{ borderRadius: 2 }}
        />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={46}
          animation="wave"
          sx={{ borderRadius: 2 }}
        />
      </div>
    </div>
  );
};
